export default "__VITE_ASSET__BZ_V3ZS6__"